// extracted by mini-css-extract-plugin
export default {"wrap":"aRQi3e","icon":"bRQi3e","wrapMargin":"cRQi3e","noUnderline":"dRQi3e"};